import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

export default function InvoiceBillingInfoModal({
  show,
  defaultValues = {},
  onClose,
  onSave,
  enableProfileInfo = false,
}) {
  const [form, setForm] = useState({});
  const [initialForm, setInitialForm] = useState({});
  const [errors, setErrors] = useState({});
  const [updateUserProfile, setUpdateUserProfile] = useState(false);
  const [paymentMode, setPaymentMode] = useState("immediate");

  // -----------------------------
  // INIT depuis profil user
  // -----------------------------
  useEffect(() => {
    if (!defaultValues) return;
    const data = {
      orderBillingType: "individual",
      orderBillingCountry: "FR",
      ...defaultValues,
    };
    setForm(data);
    setInitialForm(data);
    setErrors({});
  }, [defaultValues]);

  // -----------------------------
  // CHANGE
  // -----------------------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // -----------------------------
  // VALIDATION FRONT (simple)
  // -----------------------------
  const validate = () => {
    const errs = {};
    if (!form.orderBillingFirstname)
      errs.orderBillingFirstname = "Champ requis";

    if (!form.orderBillingLastname)
      errs.orderBillingLastname = "Champ requis";

    if (!form.orderBillingAddress)
      errs.orderBillingAddress = "Champ requis";

    if (!form.orderBillingPostcode)
      errs.orderBillingPostcode = "Champ requis";

    if (!form.orderBillingCity)
      errs.orderBillingCity = "Champ requis";

    if (!form.orderBillingEmail)
      errs.orderBillingEmail = "Champ requis";

    if (form.orderBillingType === "company") {
      if (!form.orderBillingCompany)
        errs.orderBillingCompany = "Champ requis";
      /*
            if (!form.orderBillingVATNumber)
              errs.orderBillingVATNumber = "Champ requis";
            */
    }

    setErrors(errs);

    return Object.keys(errs).length === 0;
  };

  // -----------------------------
  // SAVE (→ parent)
  // -----------------------------
  const handleSave = () => {
    if (!validate()) return;

    if (onSave) {
      onSave(
        {
          ...form,

        },
        updateUserProfile,
      );
    }

    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "success",
      title: "Informations validées",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  if (!show) return null;

  return (
    <>
      <div className="modal-backdrop fade show"></div>

      <div className="modal fade show d-block" tabIndex="-1">
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">
                Informations de facturation
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              />
            </div>

            <div className="modal-body">

              {/* TYPE */}
              <div className="mb-3">
                <label className="form-label small d-block">
                  Type de facturation : *
                </label>

                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="orderBillingType"
                    value="company"
                    checked={form.orderBillingType === "company"}
                    onChange={handleChange}
                  />
                  <label className="form-check-label">
                    Société
                  </label>
                </div>

                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="orderBillingType"
                    value="individual"
                    checked={form.orderBillingType === "individual"}
                    onChange={handleChange}
                  />
                  <label className="form-check-label">
                    Particulier
                  </label>
                </div>
              </div>

              {/* IDENTITÉ */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <input
                    className="form-control form-control-sm"
                    placeholder="Prénom"
                    name="orderBillingFirstname"
                    value={form.orderBillingFirstname || ""}
                    onChange={handleChange}
                  />
                  {errors.orderBillingFirstname && <div className="text-danger small">{errors.orderBillingFirstname}</div>}
                </div>
                <div className="col-md-6">
                  <input
                    className="form-control form-control-sm"
                    placeholder="Nom"
                    name="orderBillingLastname"
                    value={form.orderBillingLastname || ""}
                    onChange={handleChange}
                  />
                  {errors.orderBillingLastname && <div className="text-danger small">{errors.orderBillingLastname}</div>}
                </div>
              </div>

              {/* COMPANY */}
              {form.orderBillingType === "company" && (
                <>
                  <input
                    className="form-control form-control-sm mb-2"
                    placeholder="Société"
                    name="orderBillingCompany"
                    value={form.orderBillingCompany || ""}
                    onChange={handleChange}
                  />
                  {errors.orderBillingCompany && <div className="text-danger small">{errors.orderBillingCompany}</div>}
                  {/*
                  <input
                    className="form-control form-control-sm mb-3"
                    placeholder="Numero de TVA"
                    name="orderBillingVATNumber"
                    value={form.orderBillingVATNumber || ""}
                    onChange={handleChange}
                  />
                  {errors.orderBillingVATNumber && <div className="text-danger small">{errors.orderBillingVATNumber}</div>}
                  */}
                </>
              )}

              {/* ADRESSE */}
              <input
                className="form-control form-control-sm mb-2"
                placeholder="Adresse"
                name="orderBillingAddress"
                value={form.orderBillingAddress || ""}
                onChange={handleChange}
              />

              <div className="row mb-3">
                <div className="col-md-4">
                  <input
                    className="form-control form-control-sm"
                    placeholder="Code postal"
                    name="orderBillingPostcode"
                    value={form.orderBillingPostcode || ""}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-5">
                  <input
                    className="form-control form-control-sm"
                    placeholder="Ville"
                    name="orderBillingCity"
                    value={form.orderBillingCity || ""}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-3">
                  <input
                    className="form-control form-control-sm"
                    placeholder="Pays"
                    name="orderBillingCountry"
                    value={form.orderBillingCountry || "FR"}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* EMAIL */}
              <input
                className="form-control form-control-sm mb-3"
                placeholder="Email"
                name="orderBillingEmail"
                value={form.orderBillingEmail || ""}
                onChange={handleChange}
              />

              {/* PROFILE */}
              {enableProfileInfo && (
                <div className="form-check mt-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={updateUserProfile}
                    onChange={(e) =>
                      setUpdateUserProfile(e.target.checked)
                    }
                  />
                  <label className="form-check-label">
                    Enregistrer dans mon profil
                  </label>
                </div>
              )}

              {/* ACTION */}
              <div className="text-end mt-4">
                <button
                  className="btn btn-primary rounded-pill"
                  onClick={handleSave}
                >
                  Continuer
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}